export default __webpack_public_path__ + "static/media/shutterstock_568319044.5b8dc3c9.png";